<template>
<div class="patrolTemplate">
   <el-drawer :title="drawerTitle" :size="drawerWidth" :modal="false" :visible.sync="drawerShow" @close="closeMess" :wrapperClosable="false" direction="rtl" ref="drawer">
      <template-drawer v-if="drawerShow" :loading.sync="loading" :handleType="handleType" :editData="editData" :templateId="templateId" :templateName="templateName" @confirm="handleConfirm" @cancel="handleCancel"></template-drawer>
   </el-drawer>
   <div class="mainContent" :style="styleObject">
      <div class="query">
         <span>
            <!-- <el-select v-model="params.status" placeholder="模板状态">
               <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select> -->
            <el-input v-model="params.templateName" autocomplete="off" placeholder="请输入巡检模板名称"></el-input>
            <button v-if="rolePermit('polling:tem:query')" class="primaryBtn" @click="searchTable">查询</button>
         </span>
         <button v-if="rolePermit('polling:tem:add')" class="primaryBtn" @click="addClick">新增巡检模板</button>
      </div>
      <border-table :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading" :current-page="pagination.page" @currentChange="handleRoleCurrentChange" @sizeChange="handleRoleSizeChange">
         <el-table-column type="index" width="55" label="序号"></el-table-column>
         <el-table-column prop="templateName" label="模板名称"></el-table-column>
         <!-- <el-table-column prop="" label="状态">
            <template slot-scope="scope">
               <div>{{scope.row.status==1?"生效中":"未生效"}}</div>
            </template>
         </el-table-column> -->
         <el-table-column prop="" label="巡检点">
            <template slot-scope="scope">
               <span v-for="(item,index) in scope.row.pointInfo" :key="index">
                 <span>{{item.pointName}}</span><span>{{(index+1)==scope.row.pointInfo.length?'':','}}</span>
                </span>
            </template>
         </el-table-column>
<!--         <el-table-column prop="" label="巡检设备类型">
            <template slot-scope="scope">
               <span v-for="(item,index) in scope.row.typeView" :key="index">
                 <span>{{item}}</span><span>{{(index+1)==scope.row.typeView.length?'':','}}</span>
                </span>
            </template>
         </el-table-column> -->
         <el-table-column prop="" label="操作" width="170" v-if="rolePermit('polling:tem:add')||rolePermit('polling:tem:del')">
            <template slot-scope="scope">
              <!-- v-if="scope.row.status == 0" -->
               <el-button v-if="rolePermit('polling:tem:add')" @click="editClick(scope.row)" size="small" class="edit">编辑
               </el-button>
               <!-- v-if="scope.row.status == 0" -->
               <el-button v-if="rolePermit('polling:tem:del')" @click="delClick(scope.row)" size="small" class="del">删除</el-button>
               <!-- <el-button @click="upClick(scope.row)" size="small" :class="{'del':scope.row.status==2}">
                  <span>{{scope.row.status==0?"下发":scope.row.status==1?"暂停":''}}</span>
               </el-button> -->
            </template>
         </el-table-column>
      </border-table>
   </div>
</div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable";
import TemplateDrawer from "@/components/patrolManagement/TemplateDrawer";

export default {
  components: {
    BorderTable,
    TemplateDrawer
  },
  data() {
    return {
      params: {
        tenantId: "123456",
        templateName: ""
      },
      options: [
        {
          value: "",
          label: "请选择"
        },
        {
          value: "0",
          label: "未生效"
        },
        {
          value: "1",
          label: "生效中"
        }
      ],
      dataList: [],
      templateId: "", //选择行的模板ID
      templateName: "", //选择行的模板名
      styleObject: {
        height: ""
      },
      tableLoading: false,
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      drawerShow: false,
      handleType: "",
      drawerTitle: "",
      drawerWidth: "700px",
      editData:{},
    };
  },
  created() {
    this.makeheight()
  },
  mounted() {
    this.loadTable();
  },
  methods: {
    searchTable(){
      this.pagination.currentPage=1
      this.loadTable()
    },
     //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    //查询
    loadTable() {
      let params = Object.assign({}, this.params);
      params.page = this.pagination.currentPage;
      params.pageSize = this.pagination.pageSize;
      this.dataList = [];
      this.request
        .get("/front/polling/template/templatePageList", params)
        .then(res => {
          console.log(res);
          
          if (res.code == 200) {
            this.dataList = res.data.pageData;
            this.pagination.total = res.data.total;
          } else {
            this.pagination = {
              show: true,
              currentPage: 1,
              pageSize: 10,
              total: 0
            };
          }
        })
        .catch(error => console.log(error));
    },
    //表格当前页变化时
    handleRoleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.loadTable();
    },
    //表格展示条数变化时
    handleRoleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.loadTable();
    },
    //编辑
    editClick(row) {
      console.log(row);
      this.drawerShow = true;
      this.editData=row
      this.drawerTitle = "编辑巡检模板";
      this.handleType = "edit";
      this.templateId = row.id;
      this.templateName = row.name;
      this.$store.commit("saveCurrDbSource", "编辑巡检模板");
    },
    //删除
    delClick(row) {
      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.request.postParamsData("/front/polling/template/delTemplate?templateId="+row.templateId)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                let num = ''
               if (this.pagination.total > 1) {
                  num = (this.pagination.total - 1) % this.pagination.pageSize
                  if (num == 0) {
                     this.pagination.currentPage = this.pagination.currentPage - 1
                  }
               }
                this.loadTable();
              } else if (res.code == 500) {
                this.msg.warn(res.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //下发
    upClick(row) {
      let confirmMsg =
        row.status == 0
          ? "下发巡检计划后将不能再修改, 是否继续?"
          : "暂停巡检计划，是否继续?";
      this.$confirm(confirmMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          let param = {
            templateId: row.id,
            status: row.status == 0 ? 1 : 0
          };
          console.log(param);
          this.request.put("/PatrolTemplate/distribute", param).then(res => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: row.status == 0 ? "下发成功!" : "暂停成功!"
              });
              this.loadTable();
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: row.status == 0 ? "已取消下发。" : "已取消暂停。"
          });
        });
    },
    //新增
    addClick(type) {
      this.drawerShow = true;
      this.editData={}
      this.drawerTitle = "新增巡检模板";
      this.handleType = "add";
      this.templateId = "";
      this.templateName = "";
      this.$store.commit("saveCurrDbSource", "新增巡检模板");
    },
    //关闭抽屉
    closeMess() {
      this.loading = false;
    },
    //确认
    handleConfirm(data) {
      console.log(data);
      if(this.handleType=='add'){
        let params=Object.assign(data,{templateId:null})
        //保存页面巡检项信息
        this.request
          .post("/front/polling/template/saveTemplate", params)
          .then(res => {
            if (res.code == 200) {
              this.msg.success("添加成功");
            } else {
              this.msg.warn(res.msg);
            }
            this.drawerShow = false;   
            this.loadTable();
          })
          .catch(error => {
            console.log(error);
          });
      }else if(this.handleType=='edit'){
        let params=Object.assign(data,{templateId:this.editData.templateId})
           //保存页面巡检项信息
        this.request
          .post("/front/polling/template/saveTemplate", params)
          .then(res => {
            if (res.code == 200) {
              this.msg.success("编辑成功");
              this.drawerShow = false;      
              this.loadTable();                          
            } else {
              // this.msg.warn("编辑失败");
              this.msg.error("巡检点已存在,请重新选择")
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    handleTooltip(data){
      this.tip=data
    },
    //取消
    handleCancel(data) {
      console.log(data);
      this.drawerShow = false;
    },
  }
};
</script>

<style lang="scss" scoped>
.patrolTemplate {
  .query {
    margin-bottom: 20px;
  }

  .topTabs {
    height: 40px;
    background: #fff;
  }

  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .edit {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }
  }
}
</style><style lang="scss">
.patrolTemplate {
  .query {
    .el-input {
      width: 580px;
      margin-right: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }

    .el-select {
      width: 180px;
      margin-right: 10px;

      .el-input {
        width: 180px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }
    }

    .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
      border-color: #42bced;
      background: #42bced;
    }

    .el-radio.is-checked .el-radio__label {
      color: #147dd9 !important;
    }
  }
}
</style>
